import {
  call, put, takeLatest, select,
} from 'redux-saga/effects';

import {
  GET_PROCESOS_REQUEST,
} from '../../actions/constants/procesos/procesos.constants';
import { authRequest } from '../../../helpers/request.helper';
import {
  getProcesosFailureAction,
  getProcesosSuccessAction,
} from '../../actions/creators/procesos/procesos.actioncreator';

const getProcesosFromState = state => state.procesos;

function* getProcesos(action) {
  const { payload } = action;
  const {
    page, start, limit, aprobado, archivado, tipoListado, sede, desdeNc, busqueda, procesosSeleccionados,
  } = payload;
  let url = `procedimientos/?page=${page}&start=${start}&limit=${limit}&aprobado=${aprobado}&archivado=${archivado}&tipo_listado=${tipoListado}&sedes=${sede}&desde_nc=${desdeNc}`;

  const filtros = [];
  const hayBusqueda = busqueda !== null && busqueda !== '';
  if (hayBusqueda) {
    filtros.push({
      property: 'busqueda', value: busqueda, operator: 'like',
    });
  }

  if (procesosSeleccionados.length > 0) {
    filtros.push({
      property: 'procesos_seleccionados', value: procesosSeleccionados, operator: 'in',
    });
  }


  const queryString = encodeURIComponent(JSON.stringify(filtros));
  url += `&filter=${queryString}`;

  const params = {
    url,
    method: 'GET',
  };

  try {
    const response = yield call(authRequest, params);
    const { datos, success, total } = response;
    if (success) {
      const procesosFromState = yield select(getProcesosFromState);

      yield put(getProcesosSuccessAction(datos, total, page, start, limit));
    } else {
      yield put(getProcesosFailureAction());
    }
  } catch (error) {
    yield put(getProcesosFailureAction(error));
  }
}

export function* getProcesosRequest() {
  yield takeLatest(GET_PROCESOS_REQUEST, getProcesos);
}
